import Text5 from './Text5'
export default Text5
